module.exports = __webpack_public_path__ + "static/img/zdhf05.936283c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf05.png
// module id = 122
// module chunks = 0